import PasswordValidator from "password-validator";

// Password
export const runPasswordValidator = (inputString, minimumCharacters = 8, maximumCharacters = 50) => {
  if (!inputString) {
    return [false, "Password is required"];
  }
  const schema = new PasswordValidator();
  schema
    .is()
    .min(minimumCharacters) // Minimum length 8
    .is()
    .max(maximumCharacters) // Maximum length 100
    .has()
    .uppercase() // Must have uppercase letters
    .has()
    .lowercase() // Must have lowercase letters
    .has()
    .digits() // Must have digits
    .has()
    .symbols() // Must have symbols
    .has()
    .not()
    .spaces() // Should not have spaces
    .is()
    .not()
    .oneOf(["Passw0rd", "Password123"]); // Blacklist these values

  const result = schema.validate(inputString, { list: true });
  if (result.includes("min")) {
    return([false, `Password must contain at least ${minimumCharacters} characters`]);
  }
  if (result.includes("max")) {
    return [false, `Password must contain ${maximumCharacters} characters at most`];
  }
  if (result.includes("uppercase")) {
    return [false, `Password must contain uppercase characters`];
  }
  if (result.includes("lowercase")) {
    return [false, `Password must contain lowercase characters`];
  }
  if (result.includes("digits")) {
    return [false, `Password must contain a number`];
  }
  if (result.includes("symbols")) {
    return [false, `Password must contain a special character`];
  }
  if (result.includes("spaces")) {
    return [false, `Password must not contain any spaces`];
  }
  if (result.includes("oneOf")) {
    return [false, `Your password is too generic. Please use a more unique password.`]
  }
  return [true];
};